<template>
  <el-aside class="sidebar">
    <a class="creatorbtn btn-primary" :href="addDraftsUrl" target="_blank">
    <div class="addicon"><el-icon><Edit /></el-icon></div>
    <div class="addtext">发布新内容</div>
    </a>
    <el-menu
      :default-active="activePath"
      router>
      <el-menu-item index="/creator/home">
        <el-icon><House /></el-icon>
        <span>首页</span>
      </el-menu-item>
      <el-menu-item index="/creator/article">
        <el-icon><DocumentCopy /></el-icon>
        <span>内容</span>
      </el-menu-item>
      <el-menu-item index="/user/settings/avatar">
        <el-icon><Avatar /></el-icon>
        <span>用户头像</span>
      </el-menu-item>
      <el-menu-item index="/user/settings/profile">
        <el-icon><Postcard /></el-icon>
        <span>个人资料</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router"; // 导入 useRoute

const route = useRoute(); // 获取路由实例

// 计算当前激活路径
const activePath = computed(() => route.path);

const addDraftsUrl = computed(() => {
  return `/editor/create/drafts?v=1`;
});

</script>

<style scoped>
.sidebar {
  border-radius: 4px;
  position: fixed;
  top: 5rem;
  width: 200px;
  bottom:0;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
  background: #fff;
}
.el-menu {
  border-right: 1px solid #fff !important;
  width: 148px;
}
::v-deep .el-menu-item{
  font-size:16px;
}
::v-deep .el-menu-item.is-active {
  color: #cc5656;
}
.sidebar ::v-deep .el-button--danger{
  --el-button-bg-color:#cc5656;
  --el-button-border-color:#cc5656;
}
.sidebar ::v-deep .el-button:hover{
  background-color: #cc5656;
  border-color: #cc5656;
  outline: none;
  opacity:0.9;
}
.el-icon {
  margin-right: 4px;
}
a.creatorbtn {
  display:inline-block;
  font-size:16px;
  padding:6px 20px;
  position:relative;
  text-align:center;
  text-decoration:none;
  border-radius:6px;
  width:140px;
}
a.creatorbtn:hover {
  opacity:0.9;
}
a.creatorbtn:active {
  top:1px;
}
a.btn-primary {
  background:#cc5656;
  color:#FFF;
  height:23px;
  margin-top:12px;
}
.addicon{
  width:25px;
  display:block;
  float:left;
  margin-top:3px;
  margin-left:17px;
}
.addtext{
  width:80px;
  display:block;
  float:left;
}
</style>
